import { createApp } from 'vue'
import App from './App.vue'
import VueGoogleMaps from '@fawmi/vue-google-maps'

const app = createApp(App);
app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyC6-sqNORgd3BZ6gr21-YiE-7Xm0qMs9fI',
        language: 'en',
    },
    autobindAllEvents: true,
}).mount('#vendormap-app')